<template>
	<nav class="tab-set">
		<slot name="tabs" :tabs="tabs" :onTabSelected="onTabSelected">
			<Tab
				v-for="tab in tabs"
				:key="tab.id"
				:disabled="tab.disabled"
				:id="tab.id"
				:is-active="tab.isActive"
				@select="onTabSelected"
			>
				<div>{{ tab.label }}</div>
				<TeamingChip
					v-if="tab.count !== undefined"
					class-name="tab-set__item-count"
				>
					<template v-slot:text>
						{{ tab.count }}
					</template>
				</TeamingChip>
			</Tab>
		</slot>
	</nav>
</template>

<script>
import TeamingChip from "../TeamingChip";
import Tab from "./Tab";

export const makeTab = ( { id = "", label = "", isActive = false, disabled = false, count, } ) => {
	const tab = {
		id,
		label,
		isActive,
		disabled,
	};

	if ( count !== undefined ) {
		tab.count = count;
	}

	return tab;
};

export default {
	name: "TabSet",
	emits: [ "select", ],
	components: {
		Tab,
		TeamingChip,
	},
	props: {
		// TODO implement disabled prop
		// eslint-disable-next-line vue/no-unused-properties
		disabled: {
			type: Boolean,
			default: false,
		},
		/** [ { id:String, label:String, isActive:Boolean, disabled:Boolean, [count:Number], }, ... ] */
		tabs: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		onTabSelected( id ) {
			this.$emit( "select", id );
		},
	},
};
</script>

<style lang="scss" scoped>
$tabSetCountFontColor: $color1-500;
$tabSetCountBackgroundColor: $color1-100;

.tab-set {
	display: flex;
	flex-direction: row;
	gap: 2.5rem;
}

.tab-set__item-count {
	font-weight: 600;
	color: $tabSetCountFontColor;
	background: $tabSetCountBackgroundColor;
	border-radius: 1.5rem;
	margin-left: .5rem;
	padding-left: .5rem;
	padding-right: .5rem;
}
</style>
